import { useRef, useState } from "react";
import styles from "../SignIn/SignIn.module.css";
import { forgotPassword } from "../../Api/Services/Account";

export default function ForgotPassword() {
  const emailRef = useRef<HTMLInputElement>(null);
  const [emailError, setEmailError] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const sendforgotPassword = () => {
    if (emailRef.current?.value.trim() == "") {
      setEmailError(true);
      return;
    } else {
      const email: string =
        emailRef.current != null
          ? emailRef.current?.value.trim().toString()
          : "";
      forgotPassword(email).then(() => {
        setEmailSent(true);
      });
    }
  };

  return (
    <div className={styles.container}>
      <h1>Forgot password</h1>
      {emailSent == false ? (
        <>
          <p>Enter email address to receive a password reset link.</p>
          <form>
            <div className={styles.email}>
              <label htmlFor="email" className={styles.label}>
                Email address
              </label>
              <input
                ref={emailRef}
                type="email"
                id="email"
                name="email"
                className={`${styles.input} ${emailError ? "error" : ""}`}
                onBlur={() => {
                  setEmailError(false);
                }}
                placeholder="Your email address"
              />
              {emailError && <p className="error_text">Email is required.</p>}
            </div>
            <button
              type="button"
              className={`${styles.forgotPassword_button} button button_black`}
              onClick={sendforgotPassword}
            >
              Forgot password
            </button>
          </form>
        </>
      ) : (
        <>
          <p>
            A email has been sent to {emailRef.current?.value.trim()} with a
            reset password link
          </p>
        </>
      )}
    </div>
  );
}
